export default {
      id: "BRL-usage",
      viewBox: "0 0 21.4 16.4",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#BRL",
      toString: function () {
        return this.url;
      }
    }